'use client'
import AccordionLayout from '@/components/AccordionLayout'
import { Link } from 'navigation'
import { useMessages, useTranslations } from 'next-intl'
import React, { useState } from 'react'

const Faq = ({ cityName = 'London'  , cityUrl}) => {
  const t = useTranslations('city-page.faq')
  const messages = useMessages()
  const faqs = Object.keys(messages['city-page']['faq']['FAQDetails'])
  const [isExpandedIndex, setIsExpandedIndex] = useState(null)
  const electricVehicleCities = ['london', 'londres', 'paris', 'parís']
  const airportTransferCities = [
    'london',
    'londres',
    'paris',
    'parís',
    'miami',
    'new york',
    'nueva york',
    'new-york-ny',
    'miami-fl',
    'los-angeles-ca',
    'dubai'
  ]
  const handleToggleAccordion = (index) => {
    setIsExpandedIndex(isExpandedIndex === index ? null : index)
  }

  return (
    <section>
      <div className='container py-12'>
        <h3 className='heading-common mb-6'>{t('title')}</h3>
        {faqs.map((faq, index) => {
          if (
            (faq === '7' && !airportTransferCities.includes(cityUrl)) ||
            (faq === '10' && !electricVehicleCities.includes(cityUrl))
          )
            return
          const answerKey =
            faq === '7' ? `FAQDetails.${faq}.${cityUrl}.answer` : `FAQDetails.${faq}.answer`
          return (
            <AccordionLayout
              key={faq}
              title={t(`FAQDetails.${faq}.question`, { cityName: cityName })}
              content={t.rich(answerKey, {
                a: (chunks) => (
                  <a
                    target='_blank'
                    className='text-blue-600 hover:underline'
                    href={`https://${chunks}`}
                  >
                    {chunks}
                  </a>
                ),
                linkToHomePage: (chunks) => (
                  <Link className='text-blue-600 hover:underline' href={`/`}>
                    {chunks}
                  </Link>
                ),
                linkTotermsOfServices: (chunks) => (
                  <Link
                    className='text-blue-600 hover:underline'
                    href={`/terms`}
                  >
                    {chunks}
                  </Link>
                ),
                cityName: cityName,
              })}
              index={index}
              isExpanded={isExpandedIndex === index}
              onToggle={handleToggleAccordion}
            />
          )
        })}
      </div>
    </section>
  )
}

export default Faq
